import React, { useContext, lazy } from 'react';
import { colloDefault } from './Pacchi';
import __t from '../../lib/traduzioni';

import { BSSPreventivoProvider } from '../../contexts/BSSPreventivoContext';
import BSSDataContext from '../../contexts/BSSDataContext';
import { retrieveNazioni } from '../../api/tnazioni';
import { comuneById } from '../../api/tcomuni';
import DefaultLoadingComponent from '../form/DefaultLoadingComponent';
import useSWRImmutable from 'swr/immutable';
import useBSSLogger from '../../hooks/useBSSLogger';
import BSSErrorBar from '../BSSErrorBar';

const {logger} = useBSSLogger();

// const FormPreventivo = lazy(() => import(/* webpackChunkName: "FormPreventivo" */ "./FormPreventivo"));
// const FormPrezzi = lazy(() => import(/* webpackChunkName: "FormPrezzi" */'./FormPrezzi'));
// const FormMittDest = lazy(() => import(/* webpackChunkName: "FormMittDest" */'./FormMittDest'));
// const FormPagamenti = lazy(() => import(/* webpackChunkName: "FormPagamenti" */'./FormPagamenti'));

import FormPreventivo from "./FormPreventivo";
import FormPrezzi from './FormPrezzi';
import FormMittDest from './FormMittDest';
import FormPagamenti from './FormPagamenti';

import { retrieveTipispedizione } from '../../api/tipospedizione';
import { mappaTipiColli } from '../../api/ttipicolli';
import { retrieveLimitiGenerali } from '../../api/limiti';

import { calcolaPreventivi } from '../../api/estimates';
import { useLocalStorage } from 'react-use';
import { allPosts, mappaPreventivatore } from '../../api/wpposts';
import { Button, Link } from '@mui/material';
import { retrieveRubrica } from '../../api/rubrica';

import { datiIntestazioneAttiviUtente, tipiPersona } from '../../api/datiintestazione';
import { valoreAddizionaleValido } from './comparatore_prezzi/utils/funzioni';
import { Alert, Paper, Grid } from '@mui/material';
import { Typography } from "@mui/material";
import useFlashMessages from '../../hooks/useFlashmessages';
import BSSDialog from '../form/BSSDialog';
import FlashMessages from '../FlashMessages';
import DefaultErrorComponent from '../form/DefaultErrorComponent';
import { Backdrop } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import Whitespace from '../Whitespace';
import Braintree from './frammenti/pagamenti/Braintree';
import { Suspense } from 'react';
import { preventivoMapperLog } from './comparatore_prezzi/utils/funzioni';

const {nou} = spedizioniweb2;



const popolaLocalita = async (contesto, dati, nazioni) => {
    let localita = {}
    
    if(dati[`isonazione${contesto}`] !== undefined ){
        const nazione = nazioni.find(n => n.iso === dati[`isonazione${contesto}`]);
        if(nazione !== undefined){
            localita[`nazione_${contesto}`] = nazione
        }
    }

    if(dati[`idcomune${contesto}`] !== undefined){
        const comune = await comuneById(dati[`idcomune${contesto}`]);
        logger.debug("recupero il comune per id per popolare la localita", dati[`idcomune${contesto}`], contesto, comune)
        if(comune !== undefined){
            localita[`comune_${contesto}`] = comune;
        } 
    } else {
        [`cap_comune_${contesto}`, `comune_comune_${contesto}`].forEach(campo => {
            if(dati[campo] !== undefined){
                localita[campo] = dati[campo]
            }
        })
    }

    return localita;

}

const recuperaDatiDaShortcode = async (dati, nazioni = [], tipiSpedizione = []) => {

    logger.debug("ricevuto da shortcode", dati)

    const colli =  dati?.colli ?? [colloDefault];
    const tipoSelezionato = dati?.tipoSelezionato?.value ??  tipiSpedizione.find(ts => ts.def)?.id ?? -1     
    const step = dati?.step ?? 1

    if(tipoSelezionato === -1){
        logger.error("Nessun tipo di spedizione di default!!!")
    }

    let daShortcode = {
        ...(await popolaLocalita("partenza", dati, nazioni)),
        ...(await popolaLocalita("arrivo", dati, nazioni)),
        colli,
        tipoSelezionato,
        step
    }        

    return daShortcode
}

/**
 * Questo componente mostra il primo step del preventivo e permette all'utente di inserire
 * 1. località
 * 2. tipo di collo
 * 3. colli
 * 
 * I valori iniziali del form vengono presi nel seguente ordine (i precedenti vengono sovrascritti dai successivi):
 * 1. BSSDataContext.isodefault popola la nazione di default (sia per partenza che per arrivo)
 * 2. props.datiShortcode: oggetto passato dallo shortcode può scrivere su tutti i campi del primo step
 * 3. localStorage
 * 
 * @param {{
 *  datiShortcode: DatiShortcodePreventivo
 * }} props 
 * @returns 
 */
const Preventivo = (props) => {

    
    const [backdropPreventivo, setBackdropPreventivo] = useState({mostra: false, message: null});

    const [preventivoStorage = {}, aggiornaPreventivoStorage, rimuoviPreventivoStorage] = useLocalStorage("spedizioniweb2_preventivo_form");
    
    const {noQuotationsContacts: noQuotationsContactsStorage} = preventivoStorage;

    const {destLocalita = null, destPacchi = null, destSubmit = null, datiShortcode = {}, step = 1, ignoraSessione = false, abilitaPuntiRitiro = false, cfgSubmitStep1 = {}, fromStep = 1,
    noQuotationsContacts = {
        ...{
            tel: null, 
            whatsapp: null, 
            mail: null
        },
        ...noQuotationsContactsStorage
    }, ...rest} = props;

    const {isodefault} = useContext(BSSDataContext);

    let daShortcode = {};

    const datiDefault = async () => {

        let dati = {};

        const nazioni = await retrieveNazioni();

        const nazionedef = nazioni.find(n => n.iso === isodefault);
        const tipiSpedizione = await retrieveTipispedizione();
        //const misurePredefinite = await mappaTipiColli();
        //const limitiGenerali = await retrieveLimitiGenerali();
        const limitiGenerali = [{}];
        let preventivi = [];

        if(step > 1 && step !== 4){
            const datiCalcolo = convertiFormRequestCalcola(preventivoStorage)
            logger.debug("dati di calcolo dallo step precedente", datiCalcolo, preventivoStorage)
            
            if(datiCalcolo?.from?.country === undefined){
                throw(new Error(`NO_PREVIOUS_DATA`))
            }
            
            preventivi = await calcolaPreventivi(datiCalcolo)
            
        }

        daShortcode = await recuperaDatiDaShortcode(datiShortcode, nazioni, tipiSpedizione);

        logger.debug("dati ottenuti da shortcode", daShortcode)

        dati = {
            nazionedef, 
            nazioni, 
            tipiSpedizione, 
            //misurePredefinite, 
            isodefault,
            //limitiSpeciali, 
            limitiGenerali,
            daShortcode,
            preventivi,
        };

        logger.debug("dati di default e da shortcode", dati)

        let datiLoggato = {};

        
        const {stato, loggato} = await spedizioniweb2.kcChecker;
        
        if(loggato && stato === 'INITIALIZED'){
            //recupero i dati acceassibili solo se loggato:
            //recupero elenco tipi persona
            dati.tipiPersone = await tipiPersona();

            //recupero dati fatturazione
            dati.datiFatturazione = await datiIntestazioneAttiviUtente();

        }

        
        
        return {...dati};

        
    };

    const { data, error } = useSWRImmutable("/api/initialDataPreventivo", datiDefault, {
        onErrorRetry: (error, key, config, revalidate) => {
            return 
            // if(error === "NO_PREVIOUS_DATA"){
            //     logger.debug("non ho dati pregressi!")
            //     return
            // }
        }
    });

    const datiPreferenze = async () => {
        const {stato, loggato} = await spedizioniweb2.kcChecker;
        let preferenze = {};
        
        if(loggato && stato === 'INITIALIZED'){
            preferenze.misurePredefinite = await mappaTipiColli();

            //recupero rubrica
            preferenze.rubrica = await retrieveRubrica();
        }

        return preferenze
    }

    const { data: preferenze, error: erroriPreferenze, mutate: aggiornaPreferenze } = useSWRImmutable("/api/userPreferences", datiPreferenze, {
        onErrorRetry: (error, key, config, revalidate) => {
            return 
            // if(error === "NO_PREVIOUS_DATA"){
            //     logger.debug("non ho dati pregressi!")
            //     return
            // }
        }
    });

    if(error){
        logger.error("errore reperimento dati iniziali", error)
        if(error.message === `NO_PREVIOUS_DATA`){
            return <NoPreviousData />
        }
        return <DefaultErrorComponent {...{error}} />
    }

    if(!error && !data){
        return (<DefaultLoadingComponent SkeletonProps={{height: 470}} />)
    }    

    let formPreventivoProps = {
        ...props,
        preventivoStorage,
        aggiornaPreventivoStorage,
        rimuoviPreventivoStorage,
        pagine: data.pagine ?? [],
        preventivi: (data.preventivi ?? []),
        cfgSubmitStep1,
        step,
        abilitaPuntiRitiro,
        fromStep,
        noQuotationsContacts,
        defaultValues: {
            nazione_partenza: data.nazionedef,
            nazione_arrivo: data.nazionedef,
            tipoSelezionato: ((data?.tipiSpedizione ?? []).find(ts => ts.def === true) ?? {}).id,
            colli: [colloDefault],
            ...data.daShortcode,
            ...step === 1 && ignoraSessione === 1 ? {} : preventivoStorage 
        },
        
    }

    logger.debug("valori di default per form preventivo", formPreventivoProps.defaultValues, data.daShortcode)



    const datiContesto = {
        nazioni: data?.nazioni ?? [], 
        tipiSpedizione: data?.tipiSpedizione ?? [], 
        limitiGenerali: (data?.limitiGenerali ?? [{}])[0],
        tipiPersone: data.tipiPersone ?? [],  
        rubrica: preferenze?.rubrica ?? [],
        misurePredefinite: preferenze?.misurePredefinite ?? {},
        datiFatturazione: data.datiFatturazione ?? {},         
        preventivoStorage,  
        aggiornaPreferenze,
        aggiornaPreventivoStorage,
        rimuoviPreventivoStorage,    
        // limitiSpeciali: data?.limitiSpeciali ?? [],
        ...(step > 1 ? {
            datiPregressi: preventivoStorage ?? {},
            preventivi: data?.preventivi ?? []
        }: {}),
        backdropPreventivo,
        setBackdropPreventivo
    };

    logger.debug("aggiornamento contesto - preventivo", (datiContesto?.preventivi?.quotations??[]).map(preventivoMapperLog))
    

    return (
        <>
            <Suspense fallback={<DefaultLoadingComponent />}> 
                <BSSPreventivoProvider value={datiContesto}>       

                    <Backdrop 
                        sx={{zIndex: 99999, color: 'white'}}
                        open={backdropPreventivo.mostra}
                    >
                        <CircularProgress color="inherit" /> 
                        <Whitespace /> 
                        <Typography variant='h6'>
                            {backdropPreventivo.messaggio}
                        </Typography>
                    </Backdrop>    

                    <Paper sx={{mb: 2}}>
                        <FlashMessages />                   
                    </Paper>
                    
                    {step === 1 && (
                        <FormPreventivo {...formPreventivoProps} daShortcode={data.daShortcode}  />                
                    )}

                    {step === 2 && (
                        <FormPrezzi {...formPreventivoProps} daShortcode={data.daShortcode} />                
                    )}

                    {step === 3 && (                    
                        <FormMittDest {...formPreventivoProps} daShortcode={data.daShortcode} />
                    )}

                    {step === 4 && (                    
                        <FormPagamenti {...formPreventivoProps} daShortcode={data.daShortcode} />
                    )}

                    <BSSErrorBar />
                </BSSPreventivoProvider>
            </Suspense>
            
        </>
    )
    

}

/**
 * Converte i dati in db di un preventivo nel formato supportato dal form
 * 
 * @param {*} data 
 */
const convertiDBForm = data => {

    const ftmap = {
        partenza: 'from',
        arrivo: 'to'
    }

    const mdmap = {
        partenza: 'mittente',
        arrivo: 'destinatario'
    }

    let valori = {};


    /** 
     * @param {*} contesto 
     */
    const localitaMapper = contesto => {

        const ft = ftmap[contesto];
        const md = mdmap[contesto];

        const datiStep1 = () => {

            let obj = {}
            const nazione = data?.[ft]?.country ?? null;
            const isItaly = nazione?.iso ?? null;
            const comune = data?.[ft]?.city ?? null;

            obj[`nazione_${contesto}`] = nazione;
            
            if(isItaly){
                obj[`comune_${contesto}`] = comune;
            } else {
                obj[`cap_comune_${contesto}`] = comune?.cap ?? null;
                obj[`comune_comune_${contesto}`] = comune?.comune ?? null;
            }

            return obj;
        }

        const datiStep2 = () => {
            let obj = {};
            
            

            return obj;
        }

        const datiStep3 = () => {
            let obj = {};

            return obj;
        }

        return {
            ...datiStep1(),
            ...datiStep2(),
            ...datiStep3()
        };
    }

    const colliMapper = () => {


        const mappa = {
            lunghezza: "length",
            larghezza: "width",
            altezza: "height",
            peso: "weight",
            qta: "qt",
            naturamerce: "contentcode"
        }

        const colli = (data?.packages ?? []).reduce((obj, collo, indiceCollo) => ({
            obj,
            ...Object.keys(mappa).map(chiave => ({[`colli.${indiceCollo}.${chiave}`]: collo[mappa[chiave]]}))
        }), []);

        return colli;
    }

    valori = {
        ...localitaMapper("partenza"), 
        ...localitaMapper("arrivo"),
        colli: colliMapper(),
        tipoSelezionato: data?.shipmenttype?.id ?? null
    }

    logger.debug("da db a form", valori)
}

/**
 * Presi i dati dal form del preventivo li converte nel formato supportato dal server
 * 
 * @param {*} data 
 * @returns 
 */
const convertiFormRequestCalcola = data => {
    logger.info("=======> dati form preventivo: ", data);

    /**
     * 
     * @param {("partenza" | "arrivo")} contesto 
     * @returns 
     */
    const localitaMapper = contesto => ({
        country: data[`nazione_${contesto}`],
        city: (data[`nazione_${contesto}`]?.iso ?? "IT") === "IT" ? 
            data[`comune_${contesto}`] : 
            //data[`comune_${contesto}`] ?? 
            {
                id: null, 
                cap: data[`cap_comune_${contesto}`] ?? data[`comune_${contesto}`]?.cap ?? null,  
                comune: data[`comune_comune_${contesto}`] ?? data[`comune_${contesto}`]?.comune ?? null, 
                nazione: data[`nazione_${contesto}`],
                provincia: data?.[`${contesto === 'partenza' ? 'mittente' : 'destinatario'}`]?.comune?.provincia ?? null
            }
    })

    const collimapper = collo => 
        ({length: collo.lunghezza, width: collo.larghezza, height: collo.altezza, weight: collo.peso, qt: collo.qta, contentcode: collo.naturamerce ?? ""})

    const addizionaliMapper = (addizionali, preventivo) => {

        /**
         * devo convertire
         * "addizionali": {
                    "prodotto_66": {
                        "addizionale_40": false,
                        "addizionale_42": false
                    },
                    "prodotto_57": {
                        "addizionale_36": "99.99"
                    },
                    "prodotto_58": {
                        "addizionale_37": 0,
                        "addizionale_38": false
                    },
                    "prodotto_60": {
                        "addizionale_35": 0,
                        "addizionale_36": 0,
                        "addizionale_37": 0,
                        "addizionale_38": false
                    }
                },

            in 
         * {
                id,
                valore,
                prezzo: null,
                utilizzato
            }  
         */


        let addizionaliscelti = [];

        //1. devo trovare l'id del prodotto dal preventivo
        const idprodotto = preventivo?.price?.associazione?.prodotto?.id ?? null;

        if(idprodotto !== null){            

            //2. devo trovare gli addizionali utilizzati
            const addizionaliprodotto = addizionali?.[`prodotto_${idprodotto}`] ?? null;

            if(addizionaliprodotto !== null){
                //3. devo convertire l'addizionale utilizzato nell'oggetto {id, valore, prezzo, utilizzato}
                addizionaliscelti = Object.keys(addizionaliprodotto).map(chiave => {                

                    const [prefisso, id] = chiave.split("_");
                    const addizionale = preventivo.listaaddizionali.find(addizionale => Number(addizionale.id) === Number(id));
                    const tipo = addizionale?.tipo?.value ?? null;
                    const valore = addizionaliprodotto[chiave];
                    const utilizzato = valoreAddizionaleValido(valore, tipo)                

                    return {
                        id,
                        valore,
                        prezzo: null,
                        utilizzato 
                    }
                }).filter(addizionale => addizionale.utilizzato === true)
            }
            
        }
        


        return addizionaliscelti
    }

    let datiRequest = {                                
        from: localitaMapper("partenza"),
        to: localitaMapper("arrivo"),
        packages: (data?.colli ?? []).map(collimapper),
        shipmenttype: {id: data.tipoSelezionato},
        addizionali: data.addizionali ?? {}
    }

    //contacts
    if(!nou(data.mittente) || !nou(data.destinatario)){
        datiRequest.contacts = [];
    }

    if(!nou(data.mittente)){
        datiRequest.contacts = [
            ...datiRequest.contacts,
            {
                mittenteodestinatario: "M",
                ...data.mittente,
                comune: datiRequest.from.city
            }
        ]            
                    
        //delete datiRequest.contacts.mittente.indirizzo
    }

    if(!nou(data.destinatario)){
        datiRequest.contacts = [
            ...datiRequest.contacts,
            {
                mittenteodestinatario: "D",
                ...data.destinatario,
                comune: datiRequest.to.city
            }
        ]            
                    
        //delete datiRequest.contacts.destinatario.indirizzo
    }

    //order
    if(!nou(data.preventivoSelezionato)){
        datiRequest.order = {
            ...data.preventivoSelezionato,
            addizionaliscelti: addizionaliMapper(data?.addizionali ?? [], data.preventivoSelezionato),
            valmerce: data.valmerce
        }

        delete datiRequest.order.validaPreventivo;
        delete datiRequest.order.validaCodice;
    }

    //pickupdate
    if(!nou(data.dataritiro)){
        datiRequest.pickupdate = data.dataritiro;
    }

    return datiRequest;
}

const NoPreviousData = ({noMessage, message = null, noButton = false}) => {

    const datiIniziali = async () => {
        const listaPagine = await allPosts();
        
        const mappaPagine = await mappaPreventivatore();
        
        const listaPagineByID = listaPagine.reduce((obj, pagina) => ({
            ...obj,
            [pagina.ID]: pagina
        }), {})

        const idPagina = Number(mappaPagine?.step1 ?? 0)

        const pagina = listaPagineByID?.[idPagina] ?? null
    
        
        return {pagina}
    }

    const {error, data} = useSWRImmutable("/api/paginastep1", datiIniziali);

    if(!error && !data){
        return (<DefaultLoadingComponent SkeletonProps={{height: 470}} />)
    } 
    
    if(error) {
        return <DefaultErrorComponent {...{error}} />
    }

    

    const {pagina} = data;

    return (
        <div>
            {!noMessage ? (message ?? __t("nopreviousdataerror")) : ""}            
            {!noButton && (
                <Button fullWidth size="large" variant="outlined" color="primary" href={pagina?.guid ?? ""} component={Link}>
                    {__t("faispedizione")}
                </Button>
            )}
            
        </div>
        
    )
}

const DefaultSubmitErrorHandler = async (err) => {
    logger.info("=======>errore dati submit: ", err);
    const errorevent = new CustomEvent("spedizioniweb2_error", {detail: {
        message: __t("correggiperprocedere"), 
        payload: err, 
        context: "formValidation"
    }})
    document.dispatchEvent(errorevent)
    throw(err)
}

export default Preventivo;
export {convertiFormRequestCalcola, NoPreviousData, DefaultSubmitErrorHandler}
